import React from 'react';
import styled from 'styled-components';

// Selo das aulas e atividades registradas pelo I.A Prof (assistente do professor).
// Aparece so na tela: some na impressao para nao alterar o documento oficial do diario.
const Selo = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 0 6px;
    padding: 1px 8px;
    border-radius: 999px;
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    color: #4338ca;
    font-size: 11px;
    font-weight: 600;
    line-height: 18px;
    white-space: nowrap;
    vertical-align: middle;

    @media print {
        display: none !important;
    }
`;

export default function SeloIAProf({ tipo = 'atividade' }) {
    const texto = tipo === 'aula' ? 'Aula registrada pelo I.A Prof' : 'Atividade registrada pelo I.A Prof';
    return (
        <Selo className="no-print" title={texto} aria-label={texto}>
            ✦ I.A Prof
        </Selo>
    );
}

export const ehDoIAProf = (item) => item?.origem === 'iaprof';
